import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { ENV } from 'config.js'
import BugActionLabel from './BugActionLabel'
import {
  fetchNvbugs
} from './actions'

import { 
  nvbugsSelector,
  nvbugsEndSelector,
  nvbugsLoadingInitSelector,
  nvbugsLoadingRemainingSelector,
  tableFilterSelector
} from './selectors'

import {
  SHOW_INITAL_LENGTH,
  TABLE_HEAD_CONTENT
} from './constants'

import FontIcon from 'react-toolbox/lib/font_icon';
import CardLoading from 'components/display/CardLoading'
import Table from './Table'
import Chip from "react-toolbox/lib/chip";

const mapStateToProps = state => {
  return {
    nvbugs: nvbugsSelector(state),
    fetchedAll: nvbugsEndSelector(state),
    isLoadingInit: nvbugsLoadingInitSelector(state),
    isLoadingRemaining: nvbugsLoadingRemainingSelector(state),
    tableFilter: tableFilterSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchNvbugs: (id) => dispatch(fetchNvbugs(id))
  }
} 

class UpdateList extends Component {

  constructor(props){
    super(props)
    this.state = {
      showAll: false
    }
  }

  componentDidMount(){
    const { id, fetchNvbugs } = this.props
    fetchNvbugs(id)
  }

  getPlaceholder = () => (
      <div styleName='placeholder'>No NVBugs to show</div>
  )

  setShowAll = (showAll) => {
    this.setState(() => ({ showAll }))
  }

  renderSearchFilters() {
    const { tableFilter } = this.props
    let attrs = []
    Object.keys(TABLE_HEAD_CONTENT).forEach(key => {
      if (tableFilter[key]) attrs = attrs.concat(tableFilter[key])
    })
    return (
      attrs.length > 0 && <div>
        {attrs.map((a, idx) => (<Chip key={ `chip${a}${idx}`} children={a} />))}
      </div>
    )
  }

  renderEntries = () => {
    const { nvbugs } = this.props
    const { showAll } = this.state
    const slicedNvbugs = showAll ? nvbugs : nvbugs.slice(0, SHOW_INITAL_LENGTH)

    return (
      <React.Fragment>
        {this.renderSearchFilters()}
        <div className={styles.tableWrapper}>
          <Table
            sourceVal={slicedNvbugs}
            source={slicedNvbugs.map(row => ({...row, bugAction: <BugActionLabel bugAction={row.bugAction} />}))}
            tableHeadContent={TABLE_HEAD_CONTENT}
          />
        </div>
      </React.Fragment>
    )
  }

  onClickExpand = () => {
    const { showAll } = this.state
    const { fetchNvbugs, id } = this.props
    showAll ? fetchNvbugs(id) : this.setShowAll(true)
  }

  onClickHide = () => {
    this.setShowAll(false)
  }

  getExpandButton = () => {
    const { isLoadingRemaining } = this.props
    if (isLoadingRemaining) {
      return (
        <div>
          <CardLoading />
        </div>
      )
    }
    return (
      <div styleName='bottomButtonContainer' onClick={this.onClickExpand}>
        <div styleName='bottomButtonContent'>
          <FontIcon value='expand_more' />
          Show more
        </div>
      </div>
    )
  }

  getHideButton = () => {
    return (
      <div styleName='bottomButtonContainer' onClick={this.onClickHide}>
        <div styleName='bottomButtonContent'>
          <FontIcon value='expand_less' />
          Show less
        </div>
      </div>
    )
  }

  renderShowMoreShowLess = () => {
    const { nvbugs, fetchedAll } = this.props
    const { showAll } = this.state
    const countSmallerThanExists = nvbugs.length <= SHOW_INITAL_LENGTH
    const noMoreToShow = showAll && fetchedAll
    if (countSmallerThanExists) return
    if (noMoreToShow) return this.getHideButton()
    return this.getExpandButton()
  }

  render(){
    const {
      isLoadingInit,
      nvbugs
    } = this.props

    if(isLoadingInit){
      return (<CardLoading />)
    } else if(nvbugs.length === 0){
      return this.getPlaceholder()
    }
    
    return (
      <div styleName='container'>
        {this.renderEntries()}
        {this.renderShowMoreShowLess()}
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(UpdateList)
